/**
 * Counting animation effect for numeric values
 * Animates numbers counting up from 0 to target value
 */

export function startCountingEffect(containerEl) {
  if (!containerEl) return () => {};

  const elements = containerEl.querySelectorAll('[data-count-to]');
  const animations = [];
  const timeouts = [];

  elements.forEach((el) => {
    const targetValue = parseFloat(el.getAttribute('data-count-to'));
    const duration = parseFloat(el.getAttribute('data-count-duration') || '2000');
    const delay = parseFloat(el.getAttribute('data-count-delay') || '0');
    const decimals = parseInt(el.getAttribute('data-count-decimals') || '0', 10);
    const suffix = el.getAttribute('data-count-suffix') || '';
    const prefix = el.getAttribute('data-count-prefix') || '';

    if (isNaN(targetValue)) return;

    const timeoutId = setTimeout(() => {
      const startTime = Date.now();
      const startValue = 0;

      const animate = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Easing function (ease-out cubic)
        const eased = 1 - Math.pow(1 - progress, 3);
        
        const currentValue = startValue + (targetValue - startValue) * eased;
        const displayValue = currentValue.toFixed(decimals);
        
        el.textContent = prefix + displayValue + suffix;

        if (progress < 1) {
          const id = requestAnimationFrame(animate);
          animations.push(id);
        }
      };

      animate();
    }, delay);

    timeouts.push(timeoutId);
  });

  // Cleanup function
  return () => {
    timeouts.forEach((id) => clearTimeout(id));
    animations.forEach((id) => cancelAnimationFrame(id));
  };
}

/**
 * Helper to add counting animation to specific elements
 */
export function animateNumber(element, targetValue, options = {}) {
  if (!element) return () => {};

  const {
    duration = 2000,
    decimals = 0,
    suffix = '',
    prefix = '',
    startValue = 0
  } = options;

  const startTime = Date.now();
  let animationId = null;

  const animate = () => {
    const elapsed = Date.now() - startTime;
    const progress = Math.min(elapsed / duration, 1);
    
    // Easing function (ease-out cubic)
    const eased = 1 - Math.pow(1 - progress, 3);
    
    const currentValue = startValue + (targetValue - startValue) * eased;
    const displayValue = currentValue.toFixed(decimals);
    
    element.textContent = prefix + displayValue + suffix;

    if (progress < 1) {
      animationId = requestAnimationFrame(animate);
    }
  };

  animate();

  // Cleanup function
  return () => {
    if (animationId) cancelAnimationFrame(animationId);
  };
}
